"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross2"));
var _lock = _interopRequireDefault(require("cccisd-icons/lock4"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark4"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _cccisdReactRouter = require("cccisd-react-router");
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdSideMenu = _interopRequireDefault(require("cccisd-side-menu"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CurriculumTabs = function CurriculumTabs(_ref) {
  var basePath = _ref.basePath,
    currTab = _ref.currTab,
    currentTabs = _ref.currentTabs,
    assignmentLabel = _ref.label;
  var history = (0, _cccisdReactRouter.useHistory)();
  var desktopTrigger = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (desktopTrigger && desktopTrigger.current) {
      desktopTrigger.current.style.top = "calc(50vh - ".concat(desktopTrigger.current.offsetHeight / 2, "px)");
    }
  }, [desktopTrigger, desktopTrigger.current]);
  var trigger = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].mobileTrigger
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].desktopTrigger,
    ref: desktopTrigger
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].vertical
  }, assignmentLabel))));
  function renderTabs(_ref2) {
    var closeNavigation = _ref2.closeNavigation;
    return /*#__PURE__*/_react["default"].createElement("ul", {
      className: "nav nav-pills nav-stacked"
    }, currentTabs.map(function (tab, i) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: "presentation",
        key: i,
        className: (0, _classnames2["default"])(_defineProperty(_defineProperty({
          active: tab.tab === currTab,
          disabled: tab.isDisabled
        }, _style["default"].locked, tab.isLocked), _style["default"].complete, tab.isComplete))
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: function onClick() {
          if (tab.isDisabled) {
            return;
          }
          history.push("".concat(basePath, "/").concat(tab.tab));
          closeNavigation();
        }
      }, tab.isLocked && /*#__PURE__*/_react["default"].createElement(_lock["default"], {
        spaceRight: true
      }), tab.isComplete && /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-success"
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
        spaceRight: true
      })), tab.tabName));
    }));
  }
  function renderCloseButton(_ref3) {
    var closeNavigation = _ref3.closeNavigation;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuTop
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].label
    }, assignmentLabel), /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-xs btn-secondary",
      type: "button",
      onClick: closeNavigation
    }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdSideMenu["default"], {
    renderTabs: renderTabs,
    trigger: trigger,
    renderCloseButton: renderCloseButton
  });
};
CurriculumTabs.propTypes = {
  basePath: _propTypes["default"].string,
  currentTabs: _propTypes["default"].array,
  currTab: _propTypes["default"].string,
  label: _propTypes["default"].string,
  location: _propTypes["default"].object
};
var _default = exports["default"] = CurriculumTabs;